// Polyfill for Promise.withResolvers (ES2024) — required by pdfjs-dist@4.x
// Not available in Chrome < 119, Safari < 17.4, Firefox < 121
if (Promise.withResolvers === undefined) {
  (Promise as any).withResolvers = function <T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}
